// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  position: fixed;
  top: 48px;
  right: 0px;
  z-index: 10000;
  overflow: hidden;
}

.collapse-wrapper {
  margin-top: -10000000px;
  transition-property: margin-top;
  transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  transition-duration: 250ms;
}

.hud-container {
  width: calc(784px + 1rem);
  height: calc(455px + 1rem);
}

.hud-actions {
  height: 48px;
  padding: 0px 12px;
  display: flex;
  justify-content: space-between;
}

.breadcrumbs {
  font-size: medium;
}

.mat-mdc-list-base {
  margin: 0 5px 0 0;
}

.mat-mdc-list-item {
  height: 35px !important;
  border-left: 3px solid transparent;
}

.mat-expansion-panel-body {
  padding: 0 !important;
}

.popup-menu-item {
  width: 160px;
  font-size: 16px;
}

.popup-menu-item-static {
  width: 160px;
  font-size: 14px;
}

.bigIcon {
  width: 36px !important;
  height: 36px !important;
}

.biggerIcon {
  width: 30px !important;
  height: 30px !important;
  margin-right: 10px;
  font-size: 20px !important;
}

.menu-text {
  width: 100%;
  margin: auto;
  color: #90a4ae;
  font-size: 13px;
  text-align: left;
}

.menu-icon {
  padding-left: 4px;
  color: #90a4ae;
  font-weight: lighter;
  font-size: 20px;
}

.nohover:hover {
  background: unset;
  cursor: unset;
}

mat-divider.header {
  height: 20px;
  border-color: transparent;
}

.category {
  overflow: hidden;
  border-top: 1px solid grey;
}

.category .menu-text {
  padding-top: 8px;
  padding-bottom: 3px;
  font-weight: bold;
  font-size: 16px;
}

.category .menu-icon {
  padding-left: 5px;
}

mat-divider {
  margin-top: 5px;
  border-color: rgba(255, 255, 255, 0.5);
}

.uppercase {
  font-weight: bold;
  font-size: 16px;
  text-transform: uppercase;
}`, "",{"version":3,"sources":["webpack://./src/app/components/hud/hud.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,SAAA;EACA,UAAA;EACA,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,uBAAA;EACA,+BAAA;EACA,+DAAA;EACA,0BAAA;AACF;;AAEA;EACE,yBAAA;EACA,0BAAA;AACF;;AAEA;EACE,YAAA;EACA,iBAAA;EACA,aAAA;EACA,8BAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,uBAAA;EACA,kCAAA;AACF;;AACA;EACE,qBAAA;AAEF;;AACA;EACE,YAAA;EACA,eAAA;AAEF;;AACA;EACE,YAAA;EACA,eAAA;AAEF;;AACA;EACE,sBAAA;EACA,uBAAA;AAEF;;AACA;EACE,sBAAA;EACA,uBAAA;EACA,kBAAA;EACA,0BAAA;AAEF;;AACA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAEF;;AACA;EACE,iBAAA;EACA,cAAA;EACA,oBAAA;EACA,eAAA;AAEF;;AACA;EACE,iBAAA;EACA,aAAA;AAEF;;AACA;EACE,YAAA;EACA,yBAAA;AAEF;;AACA;EACE,gBAAA;EACA,0BAAA;AAEF;;AACA;EACE,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;AAEF;;AACA;EACE,iBAAA;AAEF;;AACA;EACE,eAAA;EACA,sCAAA;AAEF;;AACA;EACE,iBAAA;EACA,eAAA;EACA,yBAAA;AAEF","sourcesContent":[":host {\n  position: fixed;\n  top: 48px;\n  right: 0px;\n  z-index: 10000;\n  overflow: hidden;\n}\n\n.collapse-wrapper {\n  margin-top: -10000000px;\n  transition-property: margin-top;\n  transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  transition-duration: 250ms;\n}\n\n.hud-container {\n  width: calc(1120px * 7 / 10 + 1rem);\n  height: calc(650px * 7 / 10 + 1rem);\n}\n\n.hud-actions {\n  height: 48px;\n  padding: 0px 12px;\n  display: flex;\n  justify-content: space-between;\n}\n\n.breadcrumbs {\n  font-size: medium;\n}\n\n.mat-mdc-list-base {\n  margin: 0 5px 0 0;\n}\n\n.mat-mdc-list-item {\n  height: 35px !important;\n  border-left: 3px solid transparent;\n}\n.mat-expansion-panel-body {\n  padding: 0 !important;\n}\n\n.popup-menu-item {\n  width: 160px;\n  font-size: 16px;\n}\n\n.popup-menu-item-static {\n  width: 160px;\n  font-size: 14px;\n}\n\n.bigIcon {\n  width: 36px !important;\n  height: 36px !important;\n}\n\n.biggerIcon {\n  width: 30px !important;\n  height: 30px !important;\n  margin-right: 10px;\n  font-size: 20px !important;\n}\n\n.menu-text {\n  width: 100%;\n  margin: auto;\n  color: #90a4ae;\n  font-size: 13px;\n  text-align: left;\n}\n\n.menu-icon {\n  padding-left: 4px;\n  color: #90a4ae;\n  font-weight: lighter;\n  font-size: 20px;\n}\n\n.nohover:hover {\n  background: unset;\n  cursor: unset;\n}\n\nmat-divider.header {\n  height: 20px;\n  border-color: transparent;\n}\n\n.category {\n  overflow: hidden;\n  border-top: 1px solid grey;\n}\n\n.category .menu-text {\n  padding-top: 8px;\n  padding-bottom: 3px;\n  font-weight: bold;\n  font-size: 16px;\n}\n\n.category .menu-icon {\n  padding-left: 5px;\n}\n\nmat-divider {\n  margin-top: 5px;\n  border-color: rgba(255, 255, 255, 0.5);\n}\n\n.uppercase {\n  font-weight: bold;\n  font-size: 16px;\n  text-transform: uppercase;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
